<template>
    <NuxtLoadingIndicator />
    <DynamicDialog />

    <ConfirmDialog group="confirmation" :pt="{ mask: { style: { background: 'rgba(0, 0, 0, 0.5)' } } }">
        <template #container="{ message, acceptCallback, rejectCallback }">
            <div class="delete-confirmation-container">
                <div>
                    <div class="trash-icon-container">
                        <component :is="message.icon" class="w-6 h-6" :style="{ color: message.iconColor }" />
                    </div>
                </div>

                <div>
                    <h3 class="dialog-title">{{ message.header }}</h3>
                    <p class="dialog-text">
                        {{ message.message }}
                    </p>
                    <div class="flex items-center justify-end gap-3 mt-8">
                        <PrimeButton variant="secondary" :label="message.rejectLabel" @click="rejectCallback" class="p-btn-root_secondary"></PrimeButton>
                        <PrimeButton
                            variant="error"
                            :label="message.acceptLabel"
                            @click="acceptCallback"
                            :loading="message.isLoading"
                        ></PrimeButton>
                    </div>
                </div>
            </div>
        </template>
    </ConfirmDialog>

    <div class="min-h-screen">
        <TrustSidebar />

        <div class="nuxt-page-view" :class="{ mobile: isMobile }">
            <div class="2xl:max-w-screen-2xl 2xl:mx-auto">
                <NuxtPage />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import TrustSidebar from '~/components/layout/TrustSidebar.vue'
import DynamicDialog from 'primevue/dynamicdialog';
import ConfirmDialog from 'primevue/confirmdialog';

const { isMobile } = useIsMobile();
</script>

<style lang="scss" scoped>
.nuxt-page-view {
    margin-left: 280px;
    transition: margin-left 0.3s ease-in-out;

    &.mobile {
        @apply ml-0 ;
    }

    @media screen and (max-width: 1023.98px) {
        @apply ml-0 ;
    }
}

.delete-confirmation-container {
     @apply sm:max-w-lg sm:w-[544px] w-11/12 rounded-lg bg-white mx-auto h-auto overflow-y-auto p-6 gap-4 flex;

    .trash-icon-container {
        @apply rounded-3xl border-8 border-error-50 bg-error-50 ;
    }

    .close-button {
        @apply p-2 hover:bg-white rounded-full transition-colors;
    }

    .dialog-text {
        @apply text-gray-600 font-inter text-sm font-normal ;
    }

    .dialog-title {
        @apply text-gray-900 font-inter text-lg font-semibold mb-1 ;
    }
}
</style>
